import React, { Fragment } from 'react';
import { CmsEntities } from 'client/data/models/cms';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';

import './research-entry.scss';

export const ENTRY_RENDER_TYPE = {
  HTML: 'html',
  CONTAINER: 'container',
};

export function ResearchEntry({ entry }) {
  const entryRenderType = entry.metadata('renderType').value();
  let renderEntry = null;

  if (entryRenderType) {
    switch (entryRenderType) {
      case ENTRY_RENDER_TYPE.HTML: {
        const htmlContent = entry.metadata('htmlContent').value();
        const htmlTitle = entry.metadata('htmlTitle').value();
        renderEntry = !!htmlContent && (
          <Fragment>
            {!!htmlTitle && (
              <ContentFragment componentToUse="h2" classes="heading-3 mb-1">
                {htmlTitle}
              </ContentFragment>
            )}
            <ContentFragment classes="text-gray-darker size-16">{htmlContent}</ContentFragment>
          </Fragment>
        );
        break;
      }
      case ENTRY_RENDER_TYPE.CONTAINER: {
        renderEntry = (
          <div className="entry-container card py-1 px-1 rounded-8 mb-1_5">
            {entry.children().map(childEntry => (
              <ResearchEntry key={childEntry.id} entry={childEntry} />
            ))}
          </div>
        );
        break;
      }
      default: {
        break;
      }
    }
  }

  return !!renderEntry && <div className="media-kit-research-entry">{renderEntry}</div>;
}

ResearchEntry.propTypes = {
  entry: CmsEntities.Content.isRequired,
};
